import React, { PropTypes } from 'react';
import { Link } from 'react-router';

// Components
import Image from '../image/Image';
import Content from '../contents/content/Content';
import ExtraContent from '../contents/extraContent/ExtraContent';

const propTypes = {
  id: PropTypes.string,
  href: PropTypes.string,
  action: PropTypes.func,
  extraClasses: PropTypes.string,
  contents: PropTypes.array,
  extraContent: PropTypes.object,
  image: PropTypes.object,
};


const Card = (props) => {
  const classes = `${props.extraClasses} card`;

  const className = props.action
  ? `ui link ${classes}`
  : `ui ${classes}`;

  const image = props.image &&
    <Image image={props.image} />;

  const contents = props.contents && props.contents.map((content, i) => {
    return <Content key={i} content={content} />;
  });

  const extraContent = props.extraContent &&
    <ExtraContent content={props.extraContent} />;

  const handleClick = () => {
    if (props.action) {
      props.action(props.id);
    }
  };

  const card = props.link
  ? (
    <Link to={props.link} onClick={handleClick} className={className}>
      {image}
      {contents}
      {extraContent}
    </Link>
  )
  : (
    <div onClick={handleClick} className={className}>
      {image}
      {contents}
      {extraContent}
    </div>
  );

  return card;
};

Card.propTypes = propTypes;

export default Card;



/** WEBPACK FOOTER **
 ** ./src/components/layout/sui/card/Card.js
 **/